import { render, staticRenderFns } from "./BlockType18.vue?vue&type=template&id=c733b404&scoped=true"
import script from "./BlockType18.vue?vue&type=script&lang=ts"
export * from "./BlockType18.vue?vue&type=script&lang=ts"
import style0 from "./BlockType18.vue?vue&type=style&index=0&id=c733b404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c733b404",
  null
  
)

export default component.exports